import { fetchJSONWithTimeout } from '@noths/polaris-client-utils';

import { isProd } from 'src/environment';
import { graphqlUnifiedProductQuery } from './queries/query';
import type { UnifiedProduct } from './types/UnifiedProduct';

interface FetchUnifiedProductOptions {
  timeout?: number;
}

export const fetchUnifiedProduct = async (
  productUri: string,
  { timeout = 1000 }: FetchUnifiedProductOptions = {},
): Promise<UnifiedProduct | null> => {
  const url = isProd()
    ? 'http://unified-product-service.svc.prod.noths.com/graphql'
    : 'http://unified-product-service.svc.qa.noths.com/graphql';
  const response = await fetchJSONWithTimeout(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: {
      query: graphqlUnifiedProductQuery,
      variables: { productUri: `https://notonthehighstreet.com${productUri}` },
    },
    timeout,
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch product with URI ${productUri}: ${response.statusText}`);
  }

  const body = await response.json();

  return body.data.product as UnifiedProduct;
};
